module.exports = "<p style=\"display: none;\">\n  thin-footer works!\n</p>\n<div style=\"display: none;\"><app-cc-modal></app-cc-modal></div>\n"